const PrivacyPage = ({ onBack }: { onBack: () => void }) => {
  return (
    <div className="portal portal-legal">
      <div className="card card-legal">
        <button className="back-btn" onClick={onBack} type="button">
          ← Zurück
        </button>

        <div className="brand">
          TAPETE
        </div>

        <h1 className="legal-h1">Datenschutzhinweis</h1>
        <p className="legal-meta">Stand: Juni 2025</p>

        <div className="legal-section">
          <h2 className="legal-h2">1. Verantwortlicher</h2>
          <p className="legal-operator">
            Tapete Bar KG<br />
            Zentagasse 14, 1050 Wien<br />
            office@tapete.bar
          </p>
        </div>

        <div className="legal-section">
          <h2 className="legal-h2">2. Zweck und Rechtsgrundlage</h2>
          <p>Beim Verbinden mit dem Gäste-WLAN werden technische Verbindungsdaten automatisch verarbeitet. Dies dient folgenden Zwecken:</p>
          <ul className="legal-list">
            <li>Bereitstellung und technischer Betrieb des WLAN-Dienstes</li>
            <li>Netzwerksicherheit und Erkennung von Missbrauch</li>
            <li>Möglichkeit zur Sperrung einzelner Geräte bei Regelverstößen</li>
            <li>Erfüllung gesetzlicher Auskunftspflichten gegenüber Behörden</li>
          </ul>
          <p>
            <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO (berechtigte
            Interessen: Netzwerksicherheit, Schutz vor Missbrauch, Einhaltung gesetzlicher Pflichten).
          </p>
        </div>

        <div className="legal-section">
          <h2 className="legal-h2">3. Verarbeitete Daten</h2>
          <p>Es werden ausschließlich technisch notwendige Daten verarbeitet:</p>
          <ul className="legal-list">
            <li>MAC-Adresse des verbundenen Geräts</li>
            <li>Interne IP-Adresse (dynamisch, nur im Gäste-WLAN)</li>
            <li>Zeitpunkt und Dauer der Verbindung</li>
            <li>Übertragenes Datenvolumen (Upload/Download)</li>
            <li>Status der Captive-Portal-Bestätigung</li>
          </ul>
          <p>
            Nicht verarbeitet werden: Name, E-Mail-Adresse, Telefonnummer, Standortdaten
            oder Inhalte des Datenverkehrs.
          </p>
        </div>

        <div className="legal-section">
          <h2 className="legal-h2">4. Keine Inhaltsüberwachung</h2>
          <p>
            Der Datenverkehr der Nutzer:innen wird nicht inhaltlich überwacht. Es findet
            keine Deep Packet Inspection oder sonstige Analyse aufgerufener Inhalte statt.
          </p>
        </div>

        <div className="legal-section">
          <h2 className="legal-h2">5. Speicherdauer</h2>
          <p>
            Verbindungsprotokolle werden für <strong>maximal 7 Tage</strong> gespeichert
            und anschließend automatisch gelöscht. Bei konkretem Missbrauchsverdacht können
            betroffene Logs bis zur abschließenden Klärung länger aufbewahrt werden.
          </p>
        </div>

        <div className="legal-section">
          <h2 className="legal-h2">6. Empfänger der Daten</h2>
          <p>Daten werden grundsätzlich nicht weitergegeben. Ausnahmen:</p>
          <ul className="legal-list">
            <li><strong>Internetanbieter (ISP):</strong> im Rahmen des technischen Betriebs</li>
            <li><strong>IT-Dienstleister:</strong> als Auftragsverarbeiter (Art. 28 DSGVO)</li>
            <li><strong>Behörden:</strong> bei gesetzlicher Verpflichtung (z. B. TKG 2021, StPO)</li>
          </ul>
          <p>Keine Weitergabe zu Marketingzwecken.</p>
        </div>

        <div className="legal-section">
          <h2 className="legal-h2">7. Pflicht zur Datenweitergabe</h2>
          <p>
            Die technischen Verbindungsdaten werden automatisch beim Verbinden übertragen
            und sind für den Betrieb des Dienstes technisch erforderlich – ohne diese Daten
            ist eine Nutzung des Gäste-WLANs nicht möglich.
          </p>
        </div>

        <div className="legal-section">
          <h2 className="legal-h2">8. Deine Rechte (DSGVO)</h2>
          <ul className="legal-list">
            <li><strong>Auskunft</strong> (Art. 15) – welche Daten gespeichert sind</li>
            <li><strong>Berichtigung</strong> (Art. 16) – Korrektur unrichtiger Daten</li>
            <li><strong>Löschung</strong> (Art. 17) – Löschung deiner Daten</li>
            <li><strong>Einschränkung</strong> (Art. 18) – eingeschränkte Verarbeitung</li>
            <li><strong>Widerspruch</strong> (Art. 21) – bei Verarbeitung auf Basis berechtigter Interessen</li>
          </ul>
          <p className="legal-note">
            Da keine Registrierung stattfindet, ist eine Zuordnung zu einer Person nur
            eingeschränkt möglich. Bitte gib bei Anfragen den Verbindungszeitraum und
            Gerätetyp an.
          </p>
        </div>

        <div className="legal-section">
          <h2 className="legal-h2">9. Beschwerderecht</h2>
          <p>Du kannst dich jederzeit bei der österreichischen Datenschutzbehörde beschweren:</p>
          <p className="legal-operator">
            Datenschutzbehörde Österreich (DSB)<br />
            Barichgasse 40–42, 1030 Wien<br />
            dsb@dsb.gv.at · www.dsb.gv.at
          </p>
        </div>

        <div className="legal-section">
          <h2 className="legal-h2">10. Kontakt</h2>
          <p>Bei Fragen zum Datenschutz: <strong>office@tapete.bar</strong></p>
        </div>

        <button className="btn btn-outline" onClick={onBack} type="button">
          ← Zurück zum Portal
        </button>
      </div>
    </div>
  );
};

export default PrivacyPage;
